import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[var(--ia-border)] bg-white mt-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-display font-extrabold tracking-tight text-2xl mb-4">
            Infinite<span className="text-[var(--ia-red)]">Auctions</span>
          </div>
          <p className="text-sm text-[var(--ia-muted)] max-w-md leading-relaxed">
            Elite Sports Auction Services. We position our consignors to get the highest prices possible for sports collectibles — game-used jerseys, photo-matched memorabilia, graded cards, and museum-quality artifacts.
          </p>
          <p className="text-xs text-[var(--ia-muted)] mt-6">
            A subsidiary of Medical Care Technologies Inc. <span className="font-mono">(OTC: MDCE)</span>
          </p>
        </div>

        <div>
          <div className="tracking-eyebrow text-[var(--ia-muted)] mb-4">Marketplace</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/auctions" className="hover:text-[var(--ia-red)]">Browse Auctions</Link></li>
            <li><Link to="/consign" className="hover:text-[var(--ia-red)]">Consign with us</Link></li>
            <li><Link to="/rules" className="hover:text-[var(--ia-red)]">Auction Rules</Link></li>
            <li><Link to="/register" className="hover:text-[var(--ia-red)]">Register to Bid</Link></li>
          </ul>
        </div>

        <div>
          <div className="tracking-eyebrow text-[var(--ia-muted)] mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[var(--ia-red)]">About</Link></li>
            <li><Link to="/terms" className="hover:text-[var(--ia-red)]">User Agreement</Link></li>
            <li><a href="mailto:info@infiniteauctions.com" className="hover:text-[var(--ia-red)]">info@infiniteauctions.com</a></li>
            <li><span className="text-[var(--ia-muted)]">Buying photo-matched jerseys</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--ia-border)] py-6 text-center text-xs text-[var(--ia-muted)]">
        © {new Date().getFullYear()} Infinite Auctions LLC. All rights reserved.
      </div>
    </footer>
  );
}
